import React, { useState, useEffect } from 'react'
import Loader from '../../component/loader/Loader'
import { useDispatch, useSelector } from 'react-redux';
import { OrderListRes, OrderListTodo } from '../../redux/Slices/Orders/OrderList';
import DataTable from '../../component/data_table/DataTable';
import { RiComputerLine } from "react-icons/ri";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { IoRefreshOutline } from 'react-icons/io5'
import Flatpickr from 'react-flatpickr'
import "flatpickr/dist/themes/light.css"
import { LuFileEdit, LuTrash2 } from 'react-icons/lu';
import { LuChevronLeft, LuChevronRight } from 'react-icons/lu'
import DataTablePagination from '../../component/data_table/DataTablePagination';
import { useFormik } from 'formik';
import SaveButton from '../../component/buttons/SaveButton';
import DeleteOrder from './DeleteOrder';
import { SalesOrderPdfRes, SalesOrderPdfTodo } from '../../redux/Slices/Orders/SalesOrderPdf';
import { toast, ToastContainer } from 'react-toastify';

export default function ApprovalPendingOrder() {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [bool, setBool] = useState(false)
    const [loading, setLoading] = useState(false)
    const [pageLimit, setPageLimit] = useState(10)
    const [tableLoading, setTableLoading] = useState(false)
    const [pageSize, setPageSize] = useState(1)
    const [deleteModal, setDeleteModal] = useState(false)
    const [orderData, setOrderData] = useState(false)
    const [filterLoad, setFilterLoad] = useState(false)
    const orderList = useSelector(state => state?.OrderList?.data?.data)

    const handleSearch = (data) => {
        setTableLoading(true)
        dispatch(OrderListTodo({ "pageLimit": pageLimit, "pageSize": pageSize, "search": data, "fromDate":"", "toDate": "", })).then(() => filter_res2())
    }

    const PageSizeFun = (data) => {
        setTableLoading(true)
        setPageLimit(data)
        dispatch(OrderListTodo({ "pageLimit": pageLimit, "pageSize": pageSize, "search": "", "fromDate":"", "toDate": "", })).then(() => filter_res2())
    }

    const nextPageFun = () => {
        setTableLoading(true)
        setPageSize(prev => prev + 1);
        dispatch(OrderListTodo({ "pageLimit": pageLimit, "pageSize": pageSize, "search": "", "fromDate":"", "toDate": "", })).then(() => filter_res2())
    }
    const prevPageFun = () => {
        setTableLoading(true)
        setPageSize(prev => prev - 1);
        dispatch(OrderListTodo({ "pageLimit": pageLimit, "pageSize": pageSize, "search": "", "fromDate":"", "toDate": "", })).then(() => filter_res2())
    }

    const filter_res2 = () => {
        if (OrderListRes && OrderListRes.success) {
            setTableLoading(false)
        } else {
            setTableLoading(false)
        }
    }

    useEffect(() => {
        dispatch(OrderListTodo({ "pageLimit": pageLimit, "pageSize": pageSize, "search": "", "fromDate":"", "toDate": "", }))
    }, [pageLimit, pageSize])

    useEffect(() => {
        setLoading(true)
        dispatch(OrderListTodo({ "pageLimit": pageLimit, "pageSize": pageSize, "search": "", "fromDate":"", "toDate": "", })).then(() => orderListFun())
    }, [bool])

    const orderListFun = () => {
        if (OrderListRes && OrderListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const columnDefs = [
        {
            headerName: 'S.NO',
            field: 'filedName',
            valueGetter: `${pageLimit * pageSize} + (node.rowIndex + 1) - ${pageLimit}`,
            filter: 'false',
            suppressMenu: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            maxWidth: 70
        },
        {
            headerName: 'SO CODE',
            field: 'vpurchase_order_code',
            // cellRenderer: params => <span  style={{ fontSize: '16px', fontWeight: "600", color: 'red', cursor: 'pointer' }}>{params?.data?.vpurchase_order_code}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            maxWidth: 150
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'SO DATE',
            field: 'dpo_date1',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            maxWidth: 150

            // wrapText: true,
            // autoHeight: true,
        },


        {
            headerName: 'CUST NAME',
            field: 'vplant_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            width: 420
            // wrapText: true,
            // autoHeight: true,

        },
        {
            headerName: 'FINANCE STATUS',
            field: 'vstatus',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            maxWidth: 150
        },
        {
            headerName: 'PRICE STATUS',
            field: 'vprice_status',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            maxWidth: 150
        },
        {
            headerName: 'CITY',
            field: 'vcustomer_plant_city',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            maxWidth: 140
        },


        // {
        //   field: 'ACTIONS',
        //   cellRenderer: params =>
        //     // params.data.cstatus === 'P' ? 
        //     <div>
        //       <LuFileEdit style={{ color: 'green' }} size={20} className='ms-1'
        //         onClick={() => order_edit(params.data)}
        //       />
        //       {params.data.vdespatch_advice_no == null || params.data.vdespatch_advice_no == '' ? <LuTrash2 style={{ color: "red" }} size={20} className=' ms-3'
        //         onClick={() => OrderDelete(params.data)}
        //       /> : ''}
        //     </div>

        //   ,
        //   wrapText: true,
        //   autoHeight: true,
        //   pinned: 'right',
        //   maxWidth: 100
        // }
    ]

    return (
        <>
            <div className="conatiner-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout_head'>
                            <h5> Approval Pending Order List</h5>
                        </div>
                        <div style={{width:"350px"}}>
                            {/* <label htmlFor="" className='form_label'>Search </label> */}
                            <input
                                type="text"
                                id="filter-text-box"
                                placeholder='Search'
                                name='search'
                                // onChange={(e) => handleSearch(e.target.value)}
                                // value={""}
                                onChange={(e) => {
                                    //   setFieldValue('search', e.target.value);
                                    handleSearch(e.target.value)
                                }}
                                className="form-control form_input"
                            />
                        </div>
                        {
                            loading ?
                                <div>
                                    <Loader />
                                </div> :
                                orderList && orderList.length ?
                                    <div className='mt-2'>
                                        <DataTablePagination
                                            rowData={orderList}
                                            columnDefs={columnDefs}
                                            height={'65vh'}
                                            loading={tableLoading}
                                        />
                                        <div className='text-end pgn_tbl_footer mb-2'>
                                            <div className='d-flex justify-content-end align-items-center'>
                                                <div className="d-flex align-items-center">
                                                    <label htmlFor="" className="form-label form_label" style={{ marginBottom: 0 }}>Page Size</label>
                                                    <select className="form-select form_input ms-2" style={{ width: '12vh' }} onChange={(e) => { PageSizeFun(e.target.value); }}>
                                                        <option value="10">10</option>
                                                        <option value="20">20</option>
                                                        <option value="50">50</option>
                                                        <option value="100">100</option>
                                                        <option value="150">150</option>
                                                        <option value="200">200</option>
                                                    </select>
                                                </div>
                                                <div className='d-flex align-items-center ms-3 table_footer_pagination' style={{ marginRight: '15px' }}>
                                                    <button type='button' disabled={pageSize === 1 ? true : false} onClick={() => { prevPageFun() }} className='btn pg_btn'><span className='me-2'><LuChevronLeft style={{ marginBottom: '2px' }} size={20} /></span></button>
                                                    <p><span>{pageLimit * pageSize - pageLimit + 1}</span> to <span>{pageLimit * pageSize - pageLimit + orderList?.length}</span></p>
                                                    <button type='button' disabled={orderList?.length < pageLimit ? true : false} onClick={() => { nextPageFun() }} className='btn pg_btn'>   <span className='ms-2'><LuChevronRight style={{ marginBottom: '2px' }} size={20} /></span></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div> :
                                    <div className='empty_section mt-3'>
                                        <span>DATA NOT FOUND</span>
                                    </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
